import {apiUrl} from "./api_url";

export async function updateTrend(trend) {
    const token = localStorage.getItem('accessToken');
    if (!token) {
        throw new Error({"message":"Authorization token required","authorized":false});
    }

    try {
        const response = await fetch(`${apiUrl}/streak_count`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({numberOfDirections:trend})
        });

        const data = await response.json();

        if (response.ok) {
            return data.message;
        } else {
            throw new Error(data.message);
        }
    } catch (error) {
        console.error(error);
        throw error;
    }
}

export async function getTrend() {
    const token = localStorage.getItem('accessToken');
    if (!token) {
        throw new Error({"message":"Authorization token required","authorized":false});
    }

    try {
        const response = await fetch(`${apiUrl}/streak_count/latest`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            }
        });

        const data = await response.json();

        if (response.ok) {
            return data;
        } else {
            throw new Error(data.message);
        }
    } catch (error) {
        console.error(error);
        throw error;
    }
}
